import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../utils/useLocalStorage";
import Pagination from "../../CommonUI/Pagination/Pagination";
import { Portal } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { Vortex } from 'react-loader-spinner';
let companyInformation;

function Newlisting() {
    const [show, setShow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    const [valuebtn, setValueBtn] = useState("BSE");
    const [valuebtnsme, setValueBtnSme] = useState("main");
    const [data, setData] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);

    let getData, getDataLoose, getDataIndex, getDataTicker, fetchId,
        getDataActive, getDataNews, getDataCap, getDataBest, getDataDraft, getDataDraft2, getDataNew, getDataIpo, getDataWatch, getDataOpen, getDataClose, getDataBasis, getDataIssue, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;

    const moreContent = () => {
        navigate("/IPO/New-Listing")
    }

    useEffect(() => {
        setloadingshow(true);
        const getUrlNew = BaseURL + "Newlisting";

        if (valuebtn === "BSE") {
            fetch(`${getUrlNew}/${valuebtn}/main/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }
        else if (valuebtn === "NSE") {
            fetch(`${getUrlNew}/${valuebtn}/main/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getDataNew, "getDataNew")
                })
                .catch((error) => {
                });
        }
        else if (valuebtn === "bse") {
            fetch(`${getUrlNew}/${valuebtn}/sme/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getDataNew, "getDataNew")
                })
                .catch((error) => {
                });
        }
        else if (valuebtn === "nse") {
            fetch(`${getUrlNew}/${valuebtn}/sme/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getDataNew, "getDataNew")
                })
                .catch((error) => {
                });
        }

    }, [valuebtn]);


    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>New Listing</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>

                <Container className="add-border table-box">
                    <div>
                        <div className='NewListing'>
                            <button id="btnGain" value="BSE" className={(valuebtn === "BSE") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>BSE</button>
                            <button id="btnLoose" value="NSE" className={(valuebtn === "NSE") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>NSE</button>
                            <button id="btnGain" value="bse" className={(valuebtn === "bse") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>BSE SME</button>
                            <button id="btnLoose" value="nse" className={(valuebtn === "nse") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>NSE EMERGE</button>
                        </div>
                    </div>
                    <div className='mf-table table-responsive gainer-table'>

                        {/* tabIndex={0} updated */}
                        <div className='newhigh-table table-responsive' tabIndex={0}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-left'>Company Name</th>
                                        <th className='text-right'>Listing Date</th>
                                        <th className='text-right'>Listing Price(&#8377;)</th>
                                        <th className='text-right'>High Price(&#8377;)</th>
                                        <th className='text-right'>Low Price(&#8377;)</th>
                                        <th className='text-right'>Close Price(&#8377;)</th>
                                    </tr>
                                </thead>
                                {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                <tbody>
                                    {(data != null) != null && data.map(
                                        ({ CO_NAME, LISTDATE, LISTPRICE, HIGH, LOW, CLOSE }) => (
                                            <tr>
                                                <td className="text-left">{CO_NAME} </td>
                                                <td className="text-right"> {format(parseISO(LISTDATE.split('T')[0]), 'dd-MMM-yyyy')}</td>
                                                <td className="text-right"> {(LISTPRICE != null) ? LISTPRICE.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }


                        </div>

                        {/* <Tabs defaultActiveKey="bse" transition={true}>
                            <Tab eventKey="bse" title="BSE">
                                <div className='mf-table table-responsive gainer-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>Listing Date</th>
                                                <th className='text-right'>Listing Price(&#8377;)</th>
                                                <th className='text-right'>High Price(&#8377;)</th>
                                                <th className='text-right'>Low Price(&#8377;)</th>
                                                <th className='text-right'>Close Price(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataList && dataList.map(
                                                ({ CO_NAME, LISTDATE, LISTPRICE, HIGH, LOW, CLOSE }) => (
                                                    <tr>
                                                        <td className="text-left">{CO_NAME} </td>
                                                        <td className="text-right"> {(LISTDATE != null) ? LISTDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(LISTPRICE != null) ? LISTPRICE.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Tab>
                            <Tab eventKey="nse" title="NSE">
                                <div className='mf-table table-responsive gainer-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>Listing Date</th>
                                                <th className='text-right'>Listing Price(&#8377;)</th>
                                                <th className='text-right'>High Price(&#8377;)</th>
                                                <th className='text-right'>Low Price(&#8377;)</th>
                                                <th className='text-right'>Close Price(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataNew && dataNew.map(
                                                ({ CO_NAME, LISTDATE, LISTPRICE, HIGH, LOW, CLOSE }) => (
                                                    <tr>
                                                        <td className="text-left">{CO_NAME} </td>
                                                        <td className="text-right"> {(LISTDATE != null) ? LISTDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(LISTPRICE != null) ? LISTPRICE.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Tab>
                            <Tab eventKey="sme" title="BSE">
                                <div className='mf-table table-responsive gainer-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>Listing Date</th>
                                                <th className='text-right'>Listing Price(&#8377;)</th>
                                                <th className='text-right'>High Price(&#8377;)</th>
                                                <th className='text-right'>Low Price(&#8377;)</th>
                                                <th className='text-right'>Close Price(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataList && dataList.map(
                                                ({ CO_NAME, LISTDATE, LISTPRICE, HIGH, LOW, CLOSE }) => (
                                                    <tr>
                                                        <td className="text-left">{CO_NAME} </td>
                                                        <td className="text-right"> {(LISTDATE != null) ? LISTDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(LISTPRICE != null) ? LISTPRICE.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Tab>
                            <Tab eventKey="sme" title="BSE">
                                <div className='mf-table table-responsive gainer-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>Listing Date</th>
                                                <th className='text-right'>Listing Price(&#8377;)</th>
                                                <th className='text-right'>High Price(&#8377;)</th>
                                                <th className='text-right'>Low Price(&#8377;)</th>
                                                <th className='text-right'>Close Price(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataList && dataList.map(
                                                ({ CO_NAME, LISTDATE, LISTPRICE, HIGH, LOW, CLOSE }) => (
                                                    <tr>
                                                        <td className="text-left">{CO_NAME} </td>
                                                        <td className="text-right"> {(LISTDATE != null) ? LISTDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(LISTPRICE != null) ? LISTPRICE.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Tab>
                        </Tabs> */}
                    </div>
                </Container>
            </div>
        </>
    );
}

export default Newlisting;